/**
 * Identité d'environnement (#600).
 * Dérivée du projectId Firebase — la seule donnée d'environnement toujours
 * correcte, quel que soit le fichier environment.* compilé (le flag
 * `production` est true en acc ET en prod).
 *
 * Utilisée par le badge d'environnement du backoffice et la TitleStrategy :
 * un staff connecté à befret-acceptance ne doit jamais pouvoir confondre
 * son écran avec befret-production.
 */

import { environment } from '../../environment';

export type EnvKey = 'dev' | 'acc' | 'prod';

export interface EnvInfo {
  key: EnvKey;
  /** Libellé du badge (vide en prod : le badge n'est affiché qu'en dev/acc) */
  badgeLabel: string;
  badgeColor: string;
  /** Suffixe des titres d'onglet ('' en prod) */
  titleSuffix: string;
}

const ENV_TABLE: Record<string, EnvInfo> = {
  'befret-development': { key: 'dev', badgeLabel: 'DEV', badgeColor: '#1565C0', titleSuffix: ' DEV' },
  'befret-acceptance': { key: 'acc', badgeLabel: 'ACCEPTANCE', badgeColor: '#E65100', titleSuffix: ' ACC' },
  'befret-production': { key: 'prod', badgeLabel: '', badgeColor: '', titleSuffix: '' },
};

export function getEnvInfo(): EnvInfo {
  const projectId = environment.firebaseConfig?.projectId || '';
  // Projet inconnu = traité comme non-prod : mieux vaut un badge en trop
  // qu'une prod indistinguable
  return ENV_TABLE[projectId]
    || { key: 'dev', badgeLabel: projectId || 'ENV ?', badgeColor: '#1565C0', titleSuffix: ` ${projectId}` };
}

/** true hors production — pilote l'affichage du badge d'environnement */
export function isNonProdEnv(): boolean {
  return getEnvInfo().key !== 'prod';
}
